export * from './appointmentPurposeReducer';
export * from './bankReducer';
export * from './bedsReducer';
export * from './branchesConfigReducer';
export * from './diseasesReducer';
export * from './inPatientsReducer';
export * from './rolesReducer';
export * from './roomsReducer';
export * from './wardsReducer';
export * from './plansReducer';
export * from './discountReducer';
export * from './testStandardsReducer';
export * from './diagnosisReducer';
export * from './bulkUploadReducer';
export * from './reportReducer';
export * from './subscriptionReducer';
export * from './licenseReducer';